import(/* webpackMode: "eager" */ "/app/src/app/[locale]/refund-policy/page.tsx");
